import { Ion } from 'cesium'
import React from 'react'
import Map from './components/specific/Map/Map'

const App = () => {
	Ion.defaultAccessToken =
		'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJiNmI5YmE4Yi04ZTgyLTQyYzMtOWU5Yi1kMzIzMDM5OTM3NTEiLCJpZCI6ODUwMzgsImlhdCI6MTY0NjczNjk5OH0.P41UigNFgjLp1sZep9w8knpoJGc4iPf5-EhZ6D1CzYw'

	return <Map />
}

export default App
